import { render, staticRenderFns } from "./splitDetails.vue?vue&type=template&id=5de212a3&scoped=true&"
import script from "./splitDetails.vue?vue&type=script&lang=js&"
export * from "./splitDetails.vue?vue&type=script&lang=js&"
import style0 from "./splitDetails.vue?vue&type=style&index=0&id=5de212a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de212a3",
  null
  
)

export default component.exports